export const payloadKeyValueMap: { [key: string]: any } =  {
    //API
    "api_details" : "API details",
    "method" : "Method",
    "endpoint" : "Endpoint",
    "header" : "Header",
    // "call_id" : "Call Id", //
    "status" : "Status", //
    "request_body" : "Request body",
    "response_payload" : "Response payload",
    "ticket_id" : "Ticket Id", //
    // "date" : "Endpoint", //
    "response_key" : "Response key",
    "response_values" : "Response Values",
    "value_match" : "Value Match",
    "http_match" : "HTTP Status Match",
    "response_cache" : "Response cache",
    "replacement" : "Variable Replaced",
    "output" : "Result",
    "result" : "Result",
    "value" : "Value",
    "match" : "Match",
    "call_reference_id":"Call Reference",
    // SMS
    "number" : "Number",
    "configuration" : "Data",
    "sender_id" : "Sender id",
    "sent_time" : "Sent time",
    "template" : "Template",
    "variable" : "Variable",
    // Play
    "message" : "Message",
    "text_to_speech" : "Text-to-Speech",
    "tts" : "Text-to-Speech",
    "enabled" : "Enabled",
    "enable" : "Enabled",
    "text" : "Text",
    "speech_rate" : "Speech rate",
    "language" : "Language",
    "audio" : "Audio",
    "file_name" : "File name",
    //Jump
    "jump_to" : "Jump to",
    "destination_flow" : "Destination flow",
    "destination_widget" : "Destination widget",
    //Date and Time
    "time" : "Time",
    "time_zone" : "TimeZone",
    "branch" : "Branch",
    "type" : "Type",
    "date_range" : "Date range",
    "start_date" : "Start date",
    "end_date" : "End date",
    "start_time" : "Start date",
    "end_time" : "End date",
    "days" : "Days",
    "mon" : "Monday",
    "tue" : "Tuesday",
    "wed" : "Wednesday",
    "thu" : "Thursday",
    "fri" : "Friday",
    "sat" : "Saturday",
    "sun" : "Sunday",
    // IVR Menu
    "keypress_timeout" : "Keypress timeout",
    "callback" : "Callback",
    "on_keypress" : "On Keypress",
    "on_speech" : "On Speech",
    "speech_timeout" : "Speech timeout",
    "input_type" : "Input type",
    // call forward multiple
    "call_forward_type" : "Call forward type",
    "call_forward_number" : "Call forward number",
    "caller_id" : "Caller id",
    "call_attempted" : "Call_attempted",
    "sticky_agent" : "Sticky agent",
    "smart_dial" : "Smart dialing",
    "ringtone" : "Ringtone",
    "file_id" : "File id",
    "agent_announcement" : "Agent Announcement",
    "dial_timeout" : "Dial timeout",
    "call_recording" : "Call recording",
    "format" : "Format",
    "before_dial" : "Before dialing",
    "on_call_ans" : "On call answer",
    "on_call_end" : "On call complete",
    "before_dialing" : "before_dialing",
    "on_call_answer" : "on_call_answer",
    "on_call_complete" : "on_call_complete",
    //
    "default" : "Default",
    // Repeat
    // "repetitions" : "Number of repetition",
    "number_of_repetitions" : "Number of repetitions",
    "play_message" : "Message",
    "ivr_message" : "Message",
    // key press

    //others
    // "callee": "Callee",
    "reason": "Reason",

    // Voicemail widget
    "voicemail_timeout":"Maximum record duration",
    "voicemail_terminate":"Key to finish recording",
    "menu":"Menu options",
    "file":"File",
    "dtmf_input":"DTMF input",
    "voicemail_duration":"Voicemail duration"
}

export const daysMap:Record<string, string> = {
    "mon" : "Monday",
    "tue" : "Tuesday",
    "wed" : "Wednesday",
    "thu" : "Thursday",
    "fri" : "Friday",
    "sat" : "Saturday",
    "sun" : "Sunday",
}